import { Form, Button, Input, Typography, Card, Image, theme } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import React from 'react';
import { Navigate } from 'react-router-dom';
import ThemeConfig from '../../theme';
import { useAuth } from '../../hooks/useAuth';
import './login.css';

const { Title, Text } = Typography;

export default function Login() {
  const { login, user } = useAuth();
  const { token } = theme.useToken();

  if (user) {
    return <Navigate to="/" />;
  }

  const onFinish = values => {
    login(values);
  };

  return (
    <ThemeConfig>
      <div
        className="login-page"
        style={{
          background: `linear-gradient(150deg, ${token.colorPrimary} 0%, ${token.colorSecondary})`,
        }}
      >
        {/* subtle depth accents, purely decorative */}
        <div className="login-backdrop login-backdrop--one" />
        <div className="login-backdrop login-backdrop--two" />

        <div className="login-stack">
          <div className="login-card-logo">
            <Image
              src={`${process.env.PUBLIC_URL}/images/uab-logo.png`}
              preview={false}
              style={{ maxWidth: '300px' }}
            />
          </div>

          <Card
            className="login-card"
            style={{
              boxShadow: token.boxShadowSecondary,
            }}
          >
            <Title level={3} className="login-card-heading">
              Welcome back
            </Title>
            <Text type="secondary" className="login-card-subtitle">
              Sign in to continue
            </Text>

            <Form
              className="login-form"
              layout="vertical"
              name="login"
              onFinish={onFinish}
              autoComplete="off"
            >
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: 'Email is required',
                  },
                ]}
              >
                <Input
                  size="large"
                  prefix={<MailOutlined style={{ color: token.colorTextTertiary }} />}
                  placeholder="you@company.com"
                />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Password is required',
                  },
                ]}
              >
                <Input.Password
                  size="large"
                  prefix={<LockOutlined style={{ color: token.colorTextTertiary }} />}
                  placeholder="Enter your password"
                />
              </Form.Item>

              <Form.Item className="login-submit">
                <Button type="primary" htmlType="submit" size="large" block>
                  Login
                </Button>
              </Form.Item>
            </Form>
          </Card>

          <Text className="login-footer">© {new Date().getFullYear()} uab Securities</Text>
        </div>
      </div>
    </ThemeConfig>
  );
}
